import React from 'react'
import classes from './DashboardPatientSummary.css'
import PieBar from '../../components/PieBar'
import {
  kardiaGreen,
  kardiaYellow,
  kardiaOrange,
  unprescribedGrey,
} from '../../styles/variables/colors.css'

export const DashboardPatientSummary = props => {
  const {
    patientSummary: {
      connected,
      pending,
      total: t,
      unprescribed,
    },
  } = props

  const sections = {
    connected: {
      percentage: 0,
      color: kardiaGreen,
    },
    pending: {
      percentage: 0,
      color: kardiaYellow,
    },
    unprescribed: {
      percentage: 0,
      color: unprescribedGrey,
    },
  }

  // TODO in sprint 10, simplify this
  // premium report app, need to share these as utilities
  const getIndexOfMax = arr => arr.indexOf(Math.max(...arr))

  const getPercentages = (counts, total) => {
    if (total === 0) {
      return
    }

    let runningTotal = 0
    const int = []
    const float = []

    Object.keys(counts).forEach(key => {
      const count = counts[key] > 0 ? (counts[key] / total) * 100 : 0
      int.push(Math.trunc(count))
      float.push(count - Math.trunc(count))
    })

    const newTotals = int.slice()
    runningTotal = int.reduce((a, b) => a + b, 0)

    while (runningTotal < 100) {
      const idx = getIndexOfMax(float)
      newTotals[idx] = int[idx] + 1
      float[idx] = -1
      runningTotal += 1
    }

    let i = 0
    Object.keys(sections).forEach(key => {
      sections[key].percentage = newTotals[i]
      i += 1
    })
  }

  // TODO could use an enum shared for this route to generate a lot of this stuff
  const data = Object.assign(
    {},
    { connected },
    { pending },
    { unprescribed }
  )

  const getTotalPatientText = count => (count === 1 ? 'Total Patient' : 'Total Patients')

  getPercentages(data, t)

  return (
    <React.Fragment>
      <div className={classes.total}>
        <h2
          id="oveviewTotalPatientsCount"
          className={classes.totalHeading}
        >
          <span>{t}</span>{getTotalPatientText(t)}
        </h2>
      </div>
      <div className={classes.statsRow}>
        <div className={classes.stat}>
          <span className={classes.connectedLegend} />
          <h2
            id="overviewConnectedPatientsPercent"
            className={classes.figure}
          >
            {connected}
          </h2>
          <div className={classes.legend}>
            Connected
          </div>
        </div>

        <div className={classes.stat}>
          <span className={classes.pendingLegend} />
          <h2
            id="overviewPendingPatientsPercent"
            className={classes.figure}
          >
            {pending}
          </h2>
          <div className={classes.legend}>
            Pending
          </div>
        </div>

        <div className={classes.stat}>
          <span className={classes.unprescribedLegend} />
          <h2
            id="overviewUnprescribedPatientsPercent"
            className={classes.figure}
          >
            {unprescribed}
          </h2>
          <div className={classes.legend}>
            Not Ordered
          </div>
        </div>

      </div>

      <div className={classes.pieBarWrapper}>
        <PieBar sections={sections} />
      </div>
    </React.Fragment>
  )
}

export default DashboardPatientSummary



// WEBPACK FOOTER //
// ./src/legacy/components/DashboardPatientSummary/DashboardPatientSummary.jsx